<template>
  <div class="home">
    <div class="list">
      <div class="item">
        <div>当前质押总活跃度</div>
        <b>{{data.totalActivation}}</b>
      </div>
      <div class="item">
        <div>全网总奖励积分（产出）</div>
        <b>{{data.totalOutPutPromotionCoupons}}</b>
      </div>
      <div class="item">
        <!-- <div>已兑换奖励积分（支出）</div> -->
        <div>已质押奖励积分总量</div>
        <b>{{data.exchangePromotionCoupons}}</b>
      </div>
      <div class="item">
        <div>未质押奖励积分总量</div>
        <b>{{data.promotionCouponsBalance}}</b>
      </div>
<!--      <div class="item">-->
<!--        <div>JKC仓池总量（JKC个数）</div>-->
<!--        <b>{{data.totalJkcPool}}</b>-->
<!--      </div>-->

      <!-- <div class="item">
        <div>JKC每日释放总量（根据每笔置换合计计算）</div>
        <b>{{data.totalCashWallet}}</b>
      </div> -->
<!--      <div class="item">-->
<!--        <div>JKC已释放总量</div>-->
<!--        <b>{{data.totalReleaseJkc}}</b>-->
<!--      </div>-->
      <div class="item">
        <!-- <div>置换券总量</div> -->
        <div>已兑换JKC通证的数量</div>
        <b>{{data.ydhJkc}}</b>
      </div>
      <div class="item">
        <div>已兑换的任务包待产出的数量</div>
        <b>{{data.waitOutPutReplacementCoupons}}</b>
      </div>
<!--      <div class="item">-->
<!--        <div>未兑换JKC仓池的数量</div>-->
<!--        <b>{{data.replacementCouponsBalance}}</b>-->
<!--      </div>-->
      <div class="item">
        <div>全网总奖励积分量汇总</div>
        <b>{{data.totalOutPutPromotionCouponsSum}}</b>
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      data: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.httpGet('/admin/promotionCenter/dataStatistics').then((res) => {
        if (res.code == 200) {
					this.data = res.data
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .content-container {
  background: #f0f2f5 !important;
}
.home {
  width: 100%;
  height: calc(100vh - 130px);
  // background: #F0F2F5;
}
.list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  // &::after {
  //   content: '';
  //   width: 212px;
  // }
  box-sizing: border-box;
  padding: 15px;
  padding-top: 0;
  padding-left: 0;
  .item {
    margin-top: 15px;
    width: 212px;
    height: 100px;
    background: #ffffff;
    border-radius: 8px;
    margin-left: 15px;
    div {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 21px;
      margin-left: 24px;
    }
    b {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 38px;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 20px;
      margin-left: 24px;
    }
  }
}
</style>

